// 제플린에서 px기준으로 정의되어있어서 변환하는 함수를 만들었습니다.
const pxToRem = (size: number) => `${size / 16}rem`;

export const scale = {
  xxxxsmall: pxToRem(2),
  xxxsmall: pxToRem(4),
  xxsmall: pxToRem(6),
  xsmall: pxToRem(8),
  small: pxToRem(10),
  medium: pxToRem(12),
  large: pxToRem(16),
  xlarge: pxToRem(18),
  xxlarge: pxToRem(20),
  xxxlarge: pxToRem(24),
  xxxxlarge: pxToRem(32),
  xxxxxlarge: pxToRem(40),
  xxxxxxlarge: pxToRem(60),
};
